export const findIndexByField = <T extends Record<string, any>>(
  array: T[],
  configuration: { [K in keyof T]?: T[K] },
) => {
  const [field, value] = Object.entries(configuration)[0];

  return array.findIndex((item) => item[field] === value);
};
